import { render, staticRenderFns } from "./rsvpForm.vue?vue&type=template&id=15edd31c&scoped=true&"
import script from "./rsvpForm.vue?vue&type=script&lang=js&"
export * from "./rsvpForm.vue?vue&type=script&lang=js&"
import style0 from "./rsvpForm.vue?vue&type=style&index=0&id=15edd31c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15edd31c",
  null
  
)

export default component.exports